import React, { Component } from 'react';
import SettingsPageLayout from './SettingsPageLayout';
import {connect} from "react-redux";
import {paymentActions} from "../../_actions";
import siteSetting from "../../config/env";
import {loadStripeTerminal} from "@stripe/terminal-js";
import {paymentService} from "../../_services";
import {hairdresserService, salonService} from "../../_services";
import {userActions} from "../../_actions";
import {Close} from '../../component/SvgIcon';
import toast from '../shared/Toast';
import './SettingsModern.css';
import StripeStatusCard from './StripeStatusCard';
import { can, isSelfEmployedMe } from '../permissions/access';
var terminal;


loadStripeTerminal().then(function (StripeTerminal) {
    terminal = StripeTerminal.create({
        onFetchConnectionToken: fetchConnectionToken,
        onUnexpectedReaderDisconnect: unexpectedDisconnect,
    })
    console.log("terminal", terminal);
})

function fetchConnectionToken(){
    let self=this;
    return paymentService.fetchConnectionToken()
        .then(function (res){
            console.log("res",res.data);
            return res.data.responseData.result.secret;
        })
}

function unexpectedDisconnect(){

}
class CardReader extends Component{
    constructor(props){
        super(props);
        this.state = {
            isCardReaderRequested:false,
            cardReaderRequestError:'',
            registrationCode:'',
            cardReaderConnectError:'',
            locationId:'',
            isCardConnected:true,
            activeCLass: false,
            connectDevice: false,
            isSearchReader:false,
            cardReaderFound:true,
            discoverResult:[],
            noDevice:false,
            selectedDevice:{},
            cardReaderList:[],
            label:'',
            isTransactionEdit:false,
            selectedTransaction:1,
            showTooltip:false,
            merchantStatus:'',
            paymentMethods: {
                cash: true,
                card: true,
                other: true,
                beuCardReaders: true,
                cardOnFile: true,
                paymentLink: true,
                klarna: false,
                clearPay: false,
                tapToPay: false,
                vouchers: true
            },
            // Card-reader tips. tipRole: 'salon' (owner — applies to them +
            // employed) | 'se' (their own reader) | null (employed staff: the
            // salon's settings apply, no box). readerTipping null = defaults.
            tipRole: null,
            tipSalonId: '',
            readerTipping: null,
            readerTippingDefaults: null,
            tipsEditing: false,
            tipsSaving: false,
            tipDraft: null
        }
    }
    showTooltip=()=>{
        this.setState({
            showTooltip:true
        })
     }
     hideTooltip=()=>{
        this.setState({
            showTooltip:false
        })
     }
    componentDidMount() {
        let self=this;
        if (localStorage.getItem('accessToken')) {
            let params={
                defaultRedirectTo:localStorage.getItem('defaultRedirectTo')
            }
            params.latitude = siteSetting.default_latitude;
            params.longitude = siteSetting.default_longitude;
            self.props.dispatch(userActions.profile(params))
                .then(function (response) {
                    //console.log("response",response.data.data);
                    if(response.data.data) {
                        self.setState({
                            locationId:response.data.data.userInfo.hairdresser.stripeLocationId?response.data.data.userInfo.hairdresser.stripeLocationId:"",
                            selectedTransaction:response.data.data?.userInfo?.hairdresser?.transactionFeeType?response.data.data.userInfo.hairdresser.transactionFeeType:1,
                        })
                        if(response.data.data.userInfo?.hairdresser?.isSalonOwner===1){
                            self.setState({
                                label:response.data.data.userInfo?.hairdresser?.salon.salonName?response.data.data.userInfo?.hairdresser?.salon?.salonName+" Card Reader":""
                            })
                        }
                        self.cardReaderList(response.data.data.userInfo);
                        self.fetchPaymentMethods();
                        self.fetchTipSettings(response.data.data.userInfo);
                    }
                })

        }else{
            self.props.history.push('/')
        }
        // document.body.classList.add('setting-temps-pages');
    }

    // ── Card-reader tips ──────────────────────────────────────────────
    // A SALON setting, owner-controlled, applied to every reader at the
    // salon (tips are a property of the physical reader, so per-stylist
    // settings on a shared device could never actually work). Nobody but
    // the owner sees the box.
    fetchTipSettings = (userInfo) => {
        const hd = userInfo?.hairdresser;
        if (!hd || hd.isSalonOwner !== 1) return;
        const self = this;
        const salonId = hd.salon?._id || localStorage.getItem('salonId');
        if (!salonId) return;
        this.setState({ tipRole: 'salon', tipSalonId: salonId });
        salonService.getSalonSettings(salonId)
            .then((response) => {
                const rd = response?.data?.responseData;
                const data = (rd && rd.data) || rd;
                if (!data) return;
                self.setState({
                    readerTipping: data.readerTipping || null,
                    readerTippingDefaults: data.readerTippingDefaults || null
                });
            })
            .catch((e) => console.log('Could not load tip settings', e));
    }

    effectiveTips = () => {
        return this.state.readerTipping || this.state.readerTippingDefaults || {
            percentages: [10, 15, 20], fixedAmounts: [100, 200, 300], smartTipThreshold: 1000
        };
    }

    startTipEdit = () => {
        const t = this.effectiveTips();
        this.setState({
            tipsEditing: true,
            tipDraft: {
                percentages: [0, 1, 2].map((i) => (t.percentages[i] != null ? String(t.percentages[i]) : '')),
                fixedAmounts: [0, 1, 2].map((i) => (t.fixedAmounts[i] != null ? (t.fixedAmounts[i] / 100).toFixed(2) : '')),
                smartTipThreshold: (t.smartTipThreshold / 100).toFixed(2)
            }
        });
    }

    tipDraftChange = (key, index, value) => {
        this.setState((s) => {
            const draft = { ...s.tipDraft };
            if (index === null) draft[key] = value;
            else {
                const list = draft[key].slice();
                list[index] = value;
                draft[key] = list;
            }
            return { tipDraft: draft };
        });
    }

    // Live validation for the tip edit form. Returns { percentages, fixed,
    // threshold } message strings (undefined = fine). Mirrors the BE rules so
    // nobody meets an error only at save time.
    tipDraftIssues = () => {
        const d = this.state.tipDraft;
        if (!d) return {};
        const issues = {};
        const fmtGBP = (n) => `£${n.toFixed(2)}`;

        const pcts = d.percentages.filter((v) => String(v).trim() !== '').map(Number);
        if (!pcts.length) issues.percentages = 'Add at least one percentage option.';
        else if (pcts.some((n) => !isFinite(n) || n < 1 || n > 100)) issues.percentages = 'Percentages must be between 1 and 100.';
        else if (new Set(pcts).size !== pcts.length) issues.percentages = 'Each percentage can only appear once.';

        const threshold = Number(d.smartTipThreshold);
        const thresholdOk = isFinite(threshold) && threshold >= 1;
        if (String(d.smartTipThreshold).trim() === '' || !isFinite(threshold)) issues.threshold = 'Enter a smart tip threshold.';
        else if (threshold < 1) issues.threshold = 'The smart tip threshold must be at least £1.';

        const fixed = d.fixedAmounts.filter((v) => String(v).trim() !== '').map(Number);
        if (!fixed.length) issues.fixed = 'Add at least one fixed amount.';
        else if (fixed.some((n) => !isFinite(n) || n < 0.1)) issues.fixed = 'Fixed amounts must be at least £0.10.';
        else if (new Set(fixed).size !== fixed.length) issues.fixed = 'Each fixed amount can only appear once.';
        else if (thresholdOk) {
            const over = fixed.filter((n) => n >= threshold);
            if (over.length) {
                issues.fixed = `${over.map(fmtGBP).join(', ')} ${over.length === 1 ? 'is' : 'are'} at or above your smart tip threshold (${fmtGBP(threshold)}), so ${over.length === 1 ? 'it' : 'they'} would never be shown. Fixed amounts only appear for bills under the threshold. Lower the amount or raise the threshold.`;
            }
        }
        return issues;
    }

    // null payload = clear the override, back to Beu defaults.
    persistTips = (payload) => {
        const self = this;
        this.setState({ tipsSaving: true });
        const done = (ok, saved, serverMessage) => {
            self.setState({ tipsSaving: false });
            if (!ok) { toast.error(serverMessage || 'Could not save tip settings. Please try again.'); return; }
            self.setState({ readerTipping: saved, tipsEditing: false, tipDraft: null });
            toast.success(saved ? 'Tip settings saved. The reader picks them up within a few minutes (or on restart)' : 'Back to Beu default tips');
        };
        const serverMsg = (response) => response?.data?.error?.responseMessage || response?.data?.messages || '';
        const data = new FormData();
        data.append('salonId', this.state.tipSalonId);
        data.append('readerTipping', payload ? JSON.stringify(payload) : '');
        salonService.updateSalon(data)
            .then((response) => done(!response?.data?.errorCode && response?.data?.statusCode !== 0, payload, serverMsg(response)))
            .catch((err) => done(false, null, err?.response?.data?.error?.responseMessage));
    }

    saveTips = () => {
        const d = this.state.tipDraft;
        if (!d) return;
        const issues = this.tipDraftIssues();
        if (issues.percentages || issues.fixed || issues.threshold) return; // Save is disabled; belt and braces
        const percentages = d.percentages.filter((v) => String(v).trim() !== '').map(Number);
        const fixedAmounts = d.fixedAmounts.filter((v) => String(v).trim() !== '').map((v) => Math.round(Number(v) * 100));
        const smartTipThreshold = Math.round(Number(d.smartTipThreshold) * 100);
        this.persistTips({ percentages, fixedAmounts, smartTipThreshold });
    }

    fetchPaymentMethods = () => {
        let self = this;
        hairdresserService.getPaymentMethods({})
            .then(function (response) {
                if (response.data.statusCode === 1 && response.data.responseData.paymentMethods) {
                    self.setState({
                        paymentMethods: response.data.responseData.paymentMethods,
                        merchantStatus: response.data.responseData.merchantStatus || ''
                    });
                }
            })
            .catch(function (error) {
                console.error('Error fetching payment methods:', error);
            });
    }

    savePaymentMethods = () => {
        let self = this;
        hairdresserService.updatePaymentMethods({
            paymentMethods: this.state.paymentMethods
        })
            .then(function (response) {
                if (response.data.statusCode === 1) {
                    toast.success('Payment methods updated successfully');
                } else {
                    toast.error('Failed to update payment methods');
                }
            })
            .catch(function (error) {
                console.error('Error updating payment methods:', error);
                toast.error('Failed to update payment methods');
            });
    }
    componentWillUnmount(){
        //console.log("componentWillUnmount#####",this.props.user?.userInfo?.hairdresser?.cardReaderRequest);
        document.body.classList.remove('setting-temps-pages');
    }

    requestCardReader=()=>{
        let self=this;
        self.props.dispatch(paymentActions.requestCardReader({}))
            .then(function (response) {
                console.log("response", response.data);
                if (response.data.statusCode===1) {
                    self.setState({
                        isCardReaderRequested:true
                    })
                }else{
                    self.setState({
                        cardReaderRequestError:response.data.error.errors.responseMessage
                    })
                }
            });
    }
    addStripeTerminal=()=>{
        let self=this;
        self.props.dispatch(paymentActions.addTerminal({registrationCode:this.state.registrationCode,label:this.state.label}))
            .then(function (response) {
                console.log("response", response.data);
                if (response.data.statusCode===1) {
                    self.cardReaderList();
                    self.setState({
                        isSearchReader:false,
                        isCardReaderRequested:true
                    })
                }else{
                    self.setState({
                        cardReaderConnectError:response.data.error.responseMessage
                    })
                }
            });
    }
    disconnectCardReader=(deviceId)=>{
        let self=this;
        // await terminal.disconnectReader();
        // this.setState({
        //     isCardConnected: false
        // })
        self.props.dispatch(paymentActions.cardReaderDelete({deviceId:deviceId}))
            .then(function (response) {
                console.log("response", response.data);
                if (response.data.statusCode===1) {
                    self.cardReaderList();
                    self.setState({
                        isCardConnected: false
                    })
                }else{

                }
            })
    }

    handleDiscoverCardReader = (searchDevice)=>{
        this.setState({activeCLass: !this.state.activeCLass,
            selectedDevice:searchDevice
        })
    }
    handleConnectDevice = ()=>{
        this.setState({connectDevice: !this.state.connectDevice})
    }
    handleCancel = ()=>{
        this.setState({
            registrationCode:'',
            cardReaderConnectError:'',
            isSearchReader:false
            //activeCLass: false,
            //connectDevice: false
        })
    }

    discoverReaders=()=>{
        let self=this;
        this.setState({
            activeCLass:true,
            isSearchReader:true
        })
        const config = {simulated: siteSetting.simulated, location: this.state.locationId};
        console.log("terminal",terminal);
        terminal.discoverReaders(config).then(function(discoverResult) {
            // self.setState({
            //     isSearchReader:false
            // })
            if (discoverResult.error) {
                console.log('Failed to discover: ', discoverResult.error);
            } else if (discoverResult.discoveredReaders.length === 0) {
                self.setState({
                    noDevice:true,
                })
                console.log('No available readers.');
            } else {
                // You should show the list of discoveredReaders to the
                // cashier here and let them select which to connect to (see below).
                //this.connectReader(discoverResult);
                self.setState({
                    discoverResult:discoverResult.discoveredReaders
                })
            }
        });
    }

    connectReader=()=> {
        let selectedReader=this.state.selectedDevice
        //console.log("selectedReader",selectedReader);
        let self=this;
        // Just select the first reader here.
        //var selectedReader = discoverResult.discoveredReaders[0];

        terminal.connectReader(selectedReader).then(function (connectResult) {
            if (connectResult.error) {
                self.setState({
                    isCardConnected:false
                })
                console.log('Failed to connect: ', connectResult.error);
            } else {
                console.log('Connected to reader: ', connectResult.reader.label);
                self.cardReaderList();
                self.setState({
                    isCardConnected:true
                })
            }
        });
    }

    cardReaderList=(hairdresserInfo)=>{
        let self=this;
        self.props.dispatch(paymentActions.cardReaderList({}))
            .then(function (response){
                if (response.data.statusCode===1) {
                    self.setState({
                        cardReaderList: self.props.cardReaderList
                    },function (){
                        if(hairdresserInfo?.hairdresser?.isSalonOwner===1) {
                            let count=0;
                            const names = self.state.cardReaderList.map(obj=>{
                                count++
                            })
                            self.setState({
                                label: hairdresserInfo?.hairdresser?.salon.salonName ? hairdresserInfo?.hairdresser?.salon?.salonName + ` Card Reader (${count+1})` : ""
                            })
                        }
                    });
                }else{

                }
            })
    }

    onChanged=(e)=> {
        let self=this;
        self.setState({[e.target.name]: e.target.value});

        // if (e.target.name === 'first_name') {
        //     if (e.target.value === '' || e.target.value === null) {
        //         this.setState({
        //             fNameError: ''
        //         })
        //     } else {
        //         this.setState({
        //             fNameError: '',
        //         })
        //     }
        // }
    }

    editTransaction=()=>{
        let self=this;
        self.setState({
            isTransactionEdit:true
        });
    }

    chnageTransaction=(value)=>{
        let self=this;
        if(self.state.isTransactionEdit===true) {
            self.setState({
                selectedTransaction: value
            });
        }
    }

    saveTransactionFee=()=>{
        let self=this;
        self.setState({
            isTransactionEdit:false
        });
        let params={
            transactionFeeType:this.state.selectedTransaction
        }
        self.props.dispatch(paymentActions.updateTransactionFee(params))
            .then(function (response) {
                console.log("response",response);
            })
    }

    togglePaymentMethod = (method) => {
        // Beu money methods stay locked until Beu approves the account. The
        // server enforces this too — this just avoids a toggle that won't stick.
        const BEU_METHODS = ['beuCardReaders','cardOnFile','paymentLink','klarna','clearPay','tapToPay'];
        const pending = this.state.merchantStatus === 'pending' || this.state.merchantStatus === 'flagged';
        if (pending && BEU_METHODS.includes(method)) {
            toast.error('Beu payment methods unlock once Beu approves your account.');
            return;
        }
        this.setState(prevState => ({
            paymentMethods: {
                ...prevState.paymentMethods,
                [method]: !prevState.paymentMethods[method]
            }
        }), () => {
            // Auto-save after toggle
            this.savePaymentMethods();
        });
    }

    render(){
        let props=this.props;
        // Beu money methods (the fee-bearing rows) are locked until approval.
        const pendingMerchant = this.state.merchantStatus === 'pending' || this.state.merchantStatus === 'flagged';
        return(
            <SettingsPageLayout activeTab="card-reader" {...this.props}>
                {/* One line on whether money can move, so nobody has to sign in to Stripe to find out. */}
                <StripeStatusCard />
                {/* Card Reader Hero */}
                <div className="settings-card cr-hero">
                    <div className="cr-hero-img">
                        <img src={require('../../assets/images/card-reader.png')} alt="Card Reader" />
                    </div>
                    <div className="cr-hero-body">
                        <h2 className="cr-hero-title">Card Reader</h2>
                        <p className="cr-hero-desc">Beu fully integrates with the BBPOS WisePOS E to process card and mobile transactions seamlessly.</p>
                        <a href="https://buy.stripe.com/6oE29f3S432E4mcbIL" className="cr-hero-btn" target="_blank" rel="noopener noreferrer">Order Card Reader</a>
                        {this.state.isCardReaderRequested && <p className="cr-hero-note">Someone from Beu will be in touch to organise your card reader</p>}
                    </div>
                </div>

                {/* Connected Card Readers */}
                <div className="settings-card">
                    <div className="cr-section-header">
                        <div>
                            <h2 className="cr-section-title">Connected Card Readers</h2>
                            {(this.state.isCardConnected === false || this.state.cardReaderList.length === 0) && (
                                <p className="cr-section-sub">No connected card readers</p>
                            )}
                        </div>
                        <button className="cr-info-btn" onClick={() => this.showTooltip()}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                        </button>
                    </div>

                    {this.state.showTooltip && (
                        <div className="cr-tooltip-banner">
                            <button className="cr-tooltip-close" onClick={() => this.hideTooltip()}><Close/></button>
                            <h3 className="cr-tooltip-title">Access Settings</h3>
                            <p className="cr-tooltip-text">Enter the admin pin <strong>07139</strong> to access settings.</p>
                        </div>
                    )}

                    {this.state.isCardConnected && this.state.cardReaderList.length > 0 && (
                        <div className="cr-device-list">
                            {this.state.cardReaderList.map((device) => (
                                <div key={'cr-' + device.id} className="cr-device-row">
                                    <div className="cr-device-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="5" y="2" width="14" height="20" rx="2" />
                                            <line x1="5" y1="18" x2="19" y2="18" />
                                            <circle cx="12" cy="20" r="0.5" fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div className="cr-device-info">
                                        <span className="cr-device-name">{device.label || device.device_type}</span>
                                        <span className="cr-device-type">{device.device_type}</span>
                                    </div>
                                    <span className="cr-device-status">Connected</span>
                                    <button className="cr-device-disconnect" onClick={() => this.disconnectCardReader(device.id)}>Disconnect</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Pair New Reader — the salon's devices are `settings`; a
                    self-employed stylist always pairs their own (the server
                    enforces the same, access audit 2026-10-02). */}
                {(isSelfEmployedMe() || can('settings')) && (
                <div className="settings-card">
                    <div className="cr-section-header">
                        <h2 className="cr-section-title">Pair New Reader</h2>
                    </div>

                    {!this.state.isSearchReader ? (
                        <button className="cr-search-btn" onClick={() => this.discoverReaders()}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="8" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                            Search for Card Reader
                        </button>
                    ) : (
                        <div className="cr-pair-form">
                            <div className="cr-pair-steps">
                                <div className="cr-step">
                                    <span className="cr-step-num">1</span>
                                    <p>Turn on your BBPOS WisePOS E and connect it to the same WiFi network as the device running Beu.</p>
                                </div>
                                <div className="cr-step">
                                    <span className="cr-step-num">2</span>
                                    <p>Swipe from the left, go into settings and enter pin <strong>07139</strong>, then select generate pairing code.</p>
                                </div>
                                <div className="cr-step">
                                    <span className="cr-step-num">3</span>
                                    <p>Enter the 3 word pairing code displayed on your reader below.</p>
                                </div>
                            </div>

                            <div className="settings-form-group">
                                <label className="settings-label">Pairing Code</label>
                                <input className="settings-input" type="text" placeholder="e.g. frog-kiss-settle" value={this.state.registrationCode} name="registrationCode" onChange={this.onChanged} />
                            </div>
                            <div className="settings-form-group">
                                <label className="settings-label">Device Name</label>
                                <input className="settings-input" type="text" value={this.state.label} name="label" onChange={this.onChanged} />
                            </div>
                            {this.state.cardReaderConnectError && <p className="cr-error">{this.state.cardReaderConnectError}</p>}
                            <div className="cr-pair-actions">
                                <button className="settings-btn settings-btn-secondary" onClick={() => this.handleCancel()}>Cancel</button>
                                <button className="settings-btn settings-btn-primary" onClick={() => this.addStripeTerminal()}>Pair Reader</button>
                            </div>
                        </div>
                    )}
                </div>
                )}

                {/* Transaction Fees */}
                {props.user && props.user.userInfo && props.user.userInfo?.hairdresser?.isSalonOwner === 1 && (
                    <div className="settings-card">
                        <div className="cr-section-header">
                            <div>
                                <h2 className="cr-section-title">Transaction Fees</h2>
                                <p className="cr-section-sub">Choose who pays transaction fees for card reader payments, online deposits, cards on file, payment links, Klarna and Clearpay.</p>
                            </div>
                            {!this.state.isTransactionEdit && (
                                <button className="cr-info-btn" onClick={() => this.editTransaction()}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                                </button>
                            )}
                        </div>
                        <div className={`settings-radio-option${this.state.selectedTransaction === 1 ? ' selected' : ''}`} onClick={() => this.chnageTransaction(1)}>
                            <p>Self Employed Staff</p>
                            <input type="radio" checked={this.state.selectedTransaction === 1} name="transactionFee" readOnly />
                        </div>
                        <div className={`settings-radio-option${this.state.selectedTransaction === 2 ? ' selected' : ''}`} onClick={() => this.chnageTransaction(2)}>
                            <p>Salon (salon manager account)</p>
                            <input type="radio" checked={this.state.selectedTransaction === 2} name="transactionFee" readOnly />
                        </div>
                        {this.state.isTransactionEdit && (
                            <div className="cr-pair-actions">
                                <button className="settings-btn settings-btn-primary" onClick={() => this.saveTransactionFee()}>Save Changes</button>
                            </div>
                        )}
                    </div>
                )}

                {/* Manage Payment Methods */}
                {props.user && props.user.userInfo && props.user.userInfo?.hairdresser && (
                    <div className="settings-card">
                        <div className="cr-section-header">
                            <div>
                                <h2 className="cr-section-title">Payment Methods</h2>
                                <p className="cr-section-sub">Enable or disable payment methods available at checkout</p>
                            </div>
                        </div>

                        <div className="cr-methods-list">
                            {[
                                { key: 'beuCardReaders', label: 'Beu Card Readers', fee: '1.25% + 20p' },
                                // Tap to Pay temporarily hidden from the settings UI during pilot —
                                // enabled per stylist in the DB for John James salon only. Re-add
                                // this row once we open it up to all salons.
                                // { key: 'tapToPay', label: 'Tap to Pay on iPhone', fee: '1.50% + 20p', note: 'iOS app only · iPhone XS or later · iOS 16.4+' },
                                { key: 'cardOnFile', label: 'Card on File', fee: '1.25% + 20p' },
                                { key: 'paymentLink', label: 'Quick Pay (Link & QR)', fee: '1.25% + 20p' },
                                { key: 'klarna', label: 'Klarna', fee: '5.99% + 35p' },
                                { key: 'clearPay', label: 'Clearpay', fee: '6.99% + 30p' },
                                { key: 'vouchers', label: 'Vouchers' },
                                { key: 'cash', label: 'Cash' },
                                { key: 'card', label: 'Card' },
                                { key: 'other', label: 'Other' },
                            ].map(method => (
                                <div key={method.key} className="cr-method-row">
                                    <div className="cr-method-info">
                                        <span className="cr-method-name">{method.label}</span>
                                        {method.fee && <span className="cr-method-fee">{method.fee} *</span>}
                                        {method.note && <span className="cr-method-note" style={{ display: 'block', fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>{method.note}</span>}
                                        {pendingMerchant && method.fee && <span className="cr-method-note" style={{ display: 'block', fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>Unlocks once Beu approves your account</span>}
                                    </div>
                                    <button
                                        type="button"
                                        className={'ds-toggle' + (this.state.paymentMethods[method.key] ? ' ds-toggle--on' : '')}
                                        style={pendingMerchant && method.fee ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
                                        onClick={() => this.togglePaymentMethod(method.key)}
                                    >
                                        <span className="ds-toggle-knob" />
                                    </button>
                                </div>
                            ))}
                        </div>

                        <p className="cr-fee-note">* UK Visa/Mastercard rates shown. Higher rates apply for EEA cards (2.35% + 20p), International cards (2.75% + 20p), and Amex (2.35-2.75% + 20p).</p>
                    </div>
                )}

                {/* Card Reader Tips — owner sets the salon's (applies to them +
                    employed staff); a self-employed stylist sets their own.
                    Employed staff follow the salon, so no box for them. */}
                {this.state.tipRole && (
                    <div className="settings-card">
                        <div className="cr-section-header">
                            <div>
                                <h2 className="cr-section-title">Card Reader Tips</h2>
                                <p className="cr-section-sub">
                                    The tip options shown on every card reader at your salon, the same for all staff, including self-employed chairs. Only you can change them, and a shared reader always shows one set of tips.
                                </p>
                            </div>
                            {!this.state.tipsEditing && (
                                <span style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '999px', background: this.state.readerTipping ? '#e8f0fe' : '#f3f4f6', color: this.state.readerTipping ? '#1a56db' : '#6b7280', whiteSpace: 'nowrap' }}>
                                    {this.state.readerTipping ? 'Customised' : 'Beu defaults'}
                                </span>
                            )}
                        </div>

                        {!this.state.tipsEditing ? (
                            <>
                                <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', margin: '8px 0 16px' }}>
                                    <div>
                                        <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Percentages: bills at or over the £{(this.effectiveTips().smartTipThreshold / 100).toFixed(2)} smart tip threshold</div>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            {this.effectiveTips().percentages.map((p) => (
                                                <span key={p} style={{ padding: '6px 12px', borderRadius: '8px', background: '#f3f4f6', fontWeight: 600, fontSize: '14px' }}>{p}%</span>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Fixed amounts: bills under the £{(this.effectiveTips().smartTipThreshold / 100).toFixed(2)} smart tip threshold</div>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            {this.effectiveTips().fixedAmounts.map((a) => (
                                                <span key={a} style={{ padding: '6px 12px', borderRadius: '8px', background: '#f3f4f6', fontWeight: 600, fontSize: '14px' }}>£{(a / 100).toFixed(2)}</span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <button className="settings-btn settings-btn-primary" onClick={this.startTipEdit}>
                                        {this.state.readerTipping ? 'Edit tips' : 'Customise tips'}
                                    </button>
                                    {this.state.readerTipping && (
                                        <button className="settings-btn" disabled={this.state.tipsSaving} onClick={() => this.persistTips(null)}>
                                            Reset to Beu defaults
                                        </button>
                                    )}
                                </div>
                            </>
                        ) : (() => {
                            const issues = this.tipDraftIssues();
                            const hasIssues = !!(issues.percentages || issues.fixed || issues.threshold);
                            const draftThreshold = Number(this.state.tipDraft.smartTipThreshold);
                            const thresholdLabel = isFinite(draftThreshold) && draftThreshold >= 1 ? `£${draftThreshold.toFixed(2)}` : 'the smart tip threshold';
                            const previewPcts = this.state.tipDraft.percentages.filter((v) => String(v).trim() !== '').map((v) => `${Number(v)}%`).join(' · ');
                            const previewFixed = this.state.tipDraft.fixedAmounts.filter((v) => String(v).trim() !== '').map((v) => `£${Number(v).toFixed(2)}`).join(' · ');
                            const errStyle = { fontSize: '12px', color: '#dc2626', margin: '6px 0 0', maxWidth: '520px' };
                            return (
                            <>
                                <div style={{ margin: '8px 0 12px' }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Percentage options</div>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        {[0, 1, 2].map((i) => (
                                            <div key={i} style={{ position: 'relative' }}>
                                                <input
                                                    type="number" min="1" max="100"
                                                    className="settings-input"
                                                    style={{ width: '84px', paddingRight: '26px', ...(issues.percentages ? { borderColor: '#dc2626' } : {}) }}
                                                    value={this.state.tipDraft.percentages[i]}
                                                    placeholder={i === 0 ? '10' : ''}
                                                    onChange={(e) => this.tipDraftChange('percentages', i, e.target.value)}
                                                />
                                                <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '13px' }}>%</span>
                                            </div>
                                        ))}
                                    </div>
                                    {issues.percentages
                                        ? <p style={errStyle}>{issues.percentages}</p>
                                        : <p style={{ fontSize: '12px', color: '#9ca3af', margin: '4px 0 0' }}>Shown when the bill is {thresholdLabel} or more (your smart tip threshold). Leave a box empty to offer fewer options.</p>}
                                </div>
                                <div style={{ margin: '0 0 12px' }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Fixed amounts</div>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        {[0, 1, 2].map((i) => (
                                            <div key={i} style={{ position: 'relative' }}>
                                                <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '13px' }}>£</span>
                                                <input
                                                    type="number" min="0.10" step="0.10"
                                                    className="settings-input"
                                                    style={{ width: '92px', paddingLeft: '24px', ...(issues.fixed ? { borderColor: '#dc2626' } : {}) }}
                                                    value={this.state.tipDraft.fixedAmounts[i]}
                                                    placeholder={i === 0 ? '1.00' : ''}
                                                    onChange={(e) => this.tipDraftChange('fixedAmounts', i, e.target.value)}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    {issues.fixed
                                        ? <p style={errStyle}>{issues.fixed}</p>
                                        : <p style={{ fontSize: '12px', color: '#9ca3af', margin: '4px 0 0' }}>Shown when the bill is under your smart tip threshold of {thresholdLabel}. Each must be less than the threshold.</p>}
                                </div>
                                <div style={{ margin: '0 0 12px' }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Smart tip threshold</div>
                                    <div style={{ position: 'relative', width: '120px' }}>
                                        <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '13px' }}>£</span>
                                        <input
                                            type="number" min="1" step="1"
                                            className="settings-input"
                                            style={{ width: '100%', paddingLeft: '24px', ...(issues.threshold ? { borderColor: '#dc2626' } : {}) }}
                                            value={this.state.tipDraft.smartTipThreshold}
                                            onChange={(e) => this.tipDraftChange('smartTipThreshold', null, e.target.value)}
                                        />
                                    </div>
                                    {issues.threshold
                                        ? <p style={errStyle}>{issues.threshold}</p>
                                        : <p style={{ fontSize: '12px', color: '#9ca3af', margin: '4px 0 0' }}>The smart tip threshold splits the two: bills under it offer your fixed amounts, bills at or above it offer your percentages.</p>}
                                </div>

                                {!hasIssues && (
                                    <div style={{ margin: '0 0 16px', padding: '10px 14px', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '10px', fontSize: '13px', color: '#374151' }}>
                                        On the reader: bills under <strong>{thresholdLabel}</strong> → <strong>{previewFixed || 'None'}</strong> &nbsp;·&nbsp; bills {thresholdLabel} and over → <strong>{previewPcts || 'None'}</strong>
                                    </div>
                                )}

                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <button className="settings-btn settings-btn-primary" disabled={this.state.tipsSaving || hasIssues} style={hasIssues ? { opacity: 0.5, cursor: 'not-allowed' } : undefined} onClick={this.saveTips}>
                                        {this.state.tipsSaving ? 'Saving…' : 'Save tips'}
                                    </button>
                                    <button className="settings-btn" disabled={this.state.tipsSaving} onClick={() => this.setState({ tipsEditing: false, tipDraft: null })}>
                                        Cancel
                                    </button>
                                </div>
                            </>
                            );
                        })()}
                    </div>
                )}
            </SettingsPageLayout>
        )
    }

}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(CardReader);


